module.exports = __webpack_public_path__ + "fonts/Helios-bold.c5adec2b.woff";